import PropTypes from 'prop-types';

/**
 * Footer component - Displays metadata for AMFI items
 */
const Footer = ({ type, item, formatName }) => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				padding: '8px 12px',
				borderTop: '1px solid rgba(0, 0, 0, 0.05)',
				backgroundColor: 'white',
				fontSize: '0.8rem',
				color: 'rgba(0, 0, 0, 0.6)',
			}}
		>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
				{item.category && <span>{formatName(item.category)}</span>}
				{type === 'metric' && item.unit && <span>• {item.unit}</span>}
				{item.source && <span>• Source: {item.source}</span>}
			</div>
		</div>
	);
};

Footer.propTypes = {
	type: PropTypes.oneOf(['attribute', 'metric', 'fact', 'insight']).isRequired,
	item: PropTypes.shape({
		category: PropTypes.string,
		unit: PropTypes.string,
		source: PropTypes.string,
	}).isRequired,
	formatName: PropTypes.func.isRequired,
};

export default Footer;
